import { createContext, useMemo } from "react";
import { useWatch } from "react-hook-form";

import { useUnitSystemPreferences } from "@RequestFormV2/hooks/useUnitSystemPreferences";
import type { PackingListRow } from "@RequestFormV2/sections/PackingList/types";
import { calculatePackingListTotals } from "@RequestFormV2/sections/PackingList/utils/packingListCalculations";

interface RequestFormTotalsContextType {
  totalWeight: number;
  totalCBM: number;
  totalDimensionalWeight: number;
}

const RequestFormTotalsContext = createContext<RequestFormTotalsContextType | null>(null);

function RequestFormCalculationsProvider({ children }: { children: React.ReactNode }) {
  const packingList = useWatch({ name: "packing_list" }) as PackingListRow[] | undefined;
  const { weightUnit } = useUnitSystemPreferences();

  const value = useMemo(() => {
    const totals = calculatePackingListTotals(packingList, weightUnit);
    return {
      totalWeight: totals.totalWeight,
      totalCBM: totals.totalCBM,
      totalDimensionalWeight: 0,
    };
  }, [packingList, weightUnit]);

  return <RequestFormTotalsContext.Provider value={value}>{children}</RequestFormTotalsContext.Provider>;
}

export { RequestFormTotalsContext, RequestFormCalculationsProvider };
